import { render } from "./RouteManagementTable.vue?vue&type=template&id=5efdad28&scoped=true"
import script from "./RouteManagementTable.vue?vue&type=script&lang=js"
export * from "./RouteManagementTable.vue?vue&type=script&lang=js"

import "./RouteManagementTable.vue?vue&type=style&index=0&id=5efdad28&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efdad28"]])

export default __exports__